export const AuthError = {
    type: 'AuthError',
    text: 'Bad share_token',
};
